<template>
  <div class="step-disponibilidade">
    <div class="section-label">Onde o artigo aparece</div>

    <CAlert color="warning" v-if="!temSistema">
      Sem nenhum sistema marcado o artigo fica cadastrado, mas não aparece em
      nenhuma central de ajuda.
    </CAlert>

    <div class="step-disponibilidade__lista">
      <BooleanToggle
        v-for="sistema in sistemas"
        :key="sistema.campo"
        :label="getDescricaoAcessoSistema(sistema.campo)"
        :help="sistema.help"
        :value="!!item[sistema.campo]"
        @input="(valor) => atualizar(sistema.campo, valor)"
      />
    </div>

    <div v-if="validacao.firstError(campoErro)" class="message">
      {{ validacao.firstError(campoErro) }}
    </div>
  </div>
</template>

<script>
import BooleanToggle from "@/views/Campanhas/components/CampanhasComerciais/shared/BooleanToggle.vue";
import { getDescricaoAcessoSistema } from "@/helpers/cargas";
import { SISTEMAS_ACESSO } from "../helpers/faqLabels";

export default {
  name: "StepDisponibilidade",
  components: { BooleanToggle },
  props: {
    item: {
      type: Object,
      required: true,
    },
    validacao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sistemas: SISTEMAS_ACESSO,
    };
  },
  computed: {
    temSistema() {
      return SISTEMAS_ACESSO.some(({ campo }) => !!this.item[campo]);
    },
    /**
     * O validador cobre os cinco campos de uma vez e o simple-vue-validator
     * publica o erro no primeiro campo da lista.
     */
    campoErro() {
      return `item.${SISTEMAS_ACESSO[0].campo}`;
    },
  },
  methods: {
    getDescricaoAcessoSistema,
    atualizar(campo, valor) {
      this.$set(this.item, campo, valor);
    },
  },
};
</script>

<style scoped>
.section-label {
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  color: #344054;
  letter-spacing: 0.3px;
  background: #f2f4f7;
  border-left: 3px solid #3a3e81;
  padding: 6px 10px;
  margin-bottom: 8px;
}

.step-disponibilidade__lista {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  padding: 4px 14px;
  background: #fff;
}

.message {
  font-size: 11px;
  color: #d92d20;
  margin-top: 6px;
}
</style>
